import { databases } from "@/lib/appwrite";

export async function markNoteAsRead(noteId: string): Promise<string> {
  const updated = await databases.updateDocument(
    import.meta.env.VITE_APPWRITE_DATABASE_ID,
    import.meta.env.VITE_WORK_SESSION_NOTES_COLLECTION_ID,
    noteId,
    {
      isRead: true,
      updatedAt: new Date().toISOString(),
    }
  );

  return updated.updatedAt;
}
